<div class="mt-4 mx-5 d-flex">
  <div class="justify-content-start">
    <h4 class="ds-heading--m m-0">
      {{ "configurator.requestLicenses" | cxTranslate }}
    </h4>
  </div>
  <div
    [attr.aria-label]="'configurator.closeModalLabel' | cxTranslate"
    class="ms-auto d-flex align-items-center focusable"
    data-cy="iframe-close-icon"
    tabindex="0"
    (click)="sendCloseEvent()"
    (keyup.enter)="sendCloseEvent()"
  >
    <em
      class="focusable__element ds-cursor--pointer ds-color--grey-2 ds-icon--close ds-icon--medium"
    ></em>
  </div>
</div>

<div class="separator mt-4 mb-5"></div>

<div class="mx-5">
  <div class="mb-5">
    <ds-message
      message="{{ 'configurator.completeFormCta' | cxTranslate }} {{
        'configurator.selfServiceOrdering' | cxTranslate
      }}"
      [closable]="false"
      type="info"
    ></ds-message>
  </div>
  <dcp-contact-iframe
    [iFrameTitle]="componentTexts?.iFrameTitle"
  ></dcp-contact-iframe>
</div>
